module.exports = __webpack_public_path__ + "img/pencil.be649039.svg";